import * as ExcelJS from 'exceljs';

export const dataToWorkbook = (data: object[]) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  if (data.length > 0 && data[0]) {
    const headers = Object.keys(data[0]);
    worksheet.columns = headers.map((header) => ({
      header,
      key: header,
      width: 15,
    }));

    worksheet.addRows(data);
  }

  return workbook;
};

export const workbookToBuffer = async (workbook: ExcelJS.Workbook, format: 'csv' | 'xlsx' = 'csv') => {
  if (format === 'xlsx') {
    return {
      buffer: await workbook.xlsx.writeBuffer(),
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };
  }

  return {
    buffer: await workbook.csv.writeBuffer(),
    mimeType: 'text/csv',
  };
};

const performDownload = (
  buffer: ExcelJS.Buffer,
  mimeType: string,
  fileName: string,
  format: 'csv' | 'xlsx' = 'csv',
) => {
  const blob = new Blob([buffer], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.${format}`;
  document.body.append(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadSpreadsheet = async (data: object[], fileName: string, format: 'csv' | 'xlsx' = 'csv') => {
  const workbook = dataToWorkbook(data);
  const { buffer, mimeType } = await workbookToBuffer(workbook, format);
  performDownload(buffer, mimeType, fileName, format);
};
